module.exports = __webpack_public_path__ + "img/bg_main_sec01.9fdd4462.jpg";